import { Component, OnInit } from "@angular/core";
import { faPrint, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FormField } from "src/app/interfaces/form-field.model";
import { formatDate } from "@angular/common";
import { NotifierService } from "angular-notifier";
import { LoanStatusReportService } from "src/app/services/sales/loan-status-report.service";

@Component({
  selector: "app-loan-status-report",
  templateUrl: "./loan-status-report.component.html",
  styleUrls: ["./loan-status-report.component.css"],
})
export class LoanStatusReportComponent implements OnInit {
  faUsers = faUsers;
  faPrint = faPrint;

  FormFields: FormField[] = [
    {
      type: "date",
      id: "FromDate",
      label: "From Buyer's Order Date (dd/mm/yyyy)",
    },
    {
      type: "date",
      id: "ToDate",
      label: "To Buyer's Order Date (dd/mm/yyyy)",
    },
    {
      type: "radio",
      id: "Type",
      options: [
        {
          display: "All Buyer's Orders",
          value: "all",
        },
        {
          display: "Outstanding Buyer's Orders",
          value: "outstanding",
        },
      ],
      value: "all",
    },
    {
      type: "select",
      id: "Format",
      label: "Select format",
      options: [
        { display: "PDF", value: "pdf" },
        { display: "EXCEL", value: "excel" },
        { display: "BOTH", value: "both" },
      ],
      value: "pdf",
    },
  ];

  constructor(
    private notifier: NotifierService,
    private loanStatusReportService: LoanStatusReportService,
  ) {}

  ngOnInit() {}

  Print(): void {
    const FromDate = this.getField("FromDate").value;
    const ToDate = this.getField("ToDate").value;
    const Type = this.getField("Type").value;
    const Format = this.getField("Format").value;

    if (!FromDate || !ToDate) {
      this.notifier.notify(
        "error",
        "Please provide valid date values",
      );
      return;
    }

    if (new Date(ToDate) < new Date(FromDate)) {
      this.notifier.notify(
        "error",
        "To Buyer's Order Date must not be earlier than From Buyer's Order Date",
      );
      return;
    }

    const formattedFromDate = formatDate(
      FromDate,
      "dd/MM/yyyy",
      "en-US",
    );
    const formattedToDate = formatDate(ToDate, "dd/MM/yyyy", "en-US");

    this.loanStatusReportService
      .LoanStatusReport(Type, formattedFromDate, formattedToDate)
      .subscribe({
        next: ({ body }) => {
          if (["pdf", "both"].includes(Format)) {
            window.open(body.Name, "_blank");
          }
          if (["excel", "both"].includes(Format)) {
            window.open(body.Value, "_blank");
          }
        },
        error: () => {
          this.notifier.notify("error", "Failed to generate Loan Status Report.");
        },
      });
  }

  getField(id: string): FormField {
    return (
      this.FormFields.find((f) => f.id === id) || {
        id: "",
        type: "text",
        label: "",
        value: null,
      }
    );
  }
}
